export class RequestResponse {
  request: string;
  response: string;
  responseLength: number;
  endpoint: string;

  constructor();
  constructor(
    request: null | string,
    response: null | string,
    responseLength: null | number,
    endpoint: null | string
  );
  constructor(
    request?: null | string,
    response?: null | string,
    responseLength?: null | number,
    endpoint?: null | string
  ) {
    this.request = request ?? '';
    this.response = response ?? '';
    this.responseLength = responseLength ?? 0;
    this.endpoint = endpoint ?? '';
  }
}
